// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RfmAnalysis_container {
  width: 95%;
}
.RfmAnalysis_container h1 {
  color: var(--primary-color) !important;
}
.RfmAnalysis_container .heading {
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* margin-bottom: 6rem; */
}
.RfmAnalysis_container .heading h1 {
  font-size: 2rem;
  color: var(--primary-color) !important;
  display: flex;
  flex: 7 1;
}
.RfmAnalysis_container .heading .ant-select-selector {
  border-radius: 0.6rem !important;
  background-color: var(--primary-color);
  color: var(--white);
}
.RfmAnalysis_container .heading .anticon {
  color: var(--white) !important;
}
.RfmAnalysis_container .heading div {
  display: flex;
  gap: 2rem;
  flex: 4 1;
}
.verticalLine {
  position: absolute;
  left: 5rem;
  top: 0;
  background-color: black;
  height: 40rem;
  width: 0.4rem;
}
.HorizontalLine {
  position: absolute;
  left: 5rem;
  /* top: 0; */
  bottom: 0;
  background-color: black;
  width: 92%;
  height: 0.4rem;
}
.verticalLine_container h1 {
  transform: rotate(90deg);
  margin-bottom: 15rem;
  /* margin-top: 10rem; */
  color: black !important;
}
.verticalLine_container {
  display: flex;
  position: relative;
  align-items: flex-end;
  min-height: 40rem;
  padding-bottom: 2rem;
}
.verticalLine_container h2 {
  position: absolute;
  bottom: 0;
  left: 50%;
  top: 100%;
  color: black !important;
  font-size: 25px;
}
.RfmAnalysis_container .ReturningCustomer {
  display: flex;
  align-items: center;
  gap: 2rem;
}
.RfmAnalysis_container .ReturningCustomer div {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 50%;
  height: 7rem;
  background-color: var(--primary-color);
  border-radius: 1rem;
}
.RfmAnalysis_container .ReturningCustomer div h1 {
  color: white !important;
  margin: 0 !important;
}
.RfmAnalysis_container .ReturningCustomer p {
  /* font-size: 1.2rem; */
  font-weight: bold;
  width: 30%;
}
.ReturningCustomer_container {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.salesAnalysis_container {
  margin-top: 5rem;
}
.salesAnalysis_container h1 {
  color: black !important;
  font-size: 2rem;
}
.analysisChart_container {
  padding: 1rem;
  background-color: var(--primary-color);
  border-radius: 1rem;
}
.analysisChart_container h1 {
  color: white !important;
  font-size: 1.5rem;
  margin-left: 1rem;
}
.shopUserRFM_container h1 {
  color: var(--primary-color) !important;
}
.careemBlock_container {
  display: flex;
  gap: 2rem;
  align-items: center;
}
.value_container {
  text-align: center;
}
.value_container div {
  padding: 2rem 5rem;
  background-color: var(--primary-color);
  border-radius: 1rem;
  text-align: center;
  color: var(--white);
  font-size: 1.2rem;
  min-width: 15rem;
}
.value_containers_div {
  display: flex;
  justify-content: flex-start;
  gap: 4rem;
  flex: 8 1;
}
.slider-div {
  overflow-x: scroll;
}
.twelve-month-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  margin: 1rem 0;
}
.twelve-month-container .twelve-month-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 0.5rem;
}
.twelve-month-container .twelve-month-card .title {
  color: var(--green) !important;
  font-weight: 600;
}
.ScatterChart_header {
  /* display: flex; */
  justify-content: space-between;
  align-items: center;
}
.ScatterChart_header h1 {
  color: var(--primary-color) !important;
}
.ScatterChart_header .ant-select:not(.ant-select-customize-input) .ant-select-selector {
  background-color: var(--primary-color) !important;
  width: 10rem;
  color: var(--white);
  border-radius: 0.5rem;
}
.ScatterChart_header .ant-select span {
  color: white;
}
/* .ScatterChart_header div {
  display: flex;
  gap: 1rem;
} */
.ScatterChart_header_container {
  display: flex;
  justify-content: space-evenly;
  gap: 3rem;
}
.ScatterChart_header_container .text_div h1 {
  color: var(--white) !important;
}
.ScatterChart_header_container .text_div li {
  list-style: none;
  text-align: left;
}
.ScatterChart_header_container .text_div {
  padding: 2rem;
  background-color: var(--primary-color);
  border-radius: 1rem;
  color: var(--white);
  height: 20rem;
  width: 25rem;
}
.ScatterChart_header_container .chart_div {
  background-color: var(--primary-color);
  padding: 2rem;
  border-radius: 1rem;
  width: 100%;
  position: relative;
  padding-left: 5rem;
}
.ScatterChart_header_container .chart_div .value {
  position: absolute;
  bottom: 40%;
  left: 1%;
  color: var(--white);
  font-size: 1.5rem;
  transform: rotate(-90deg);
}

.ScatterChart_header_container .chart_div .date {
  position: absolute;
  bottom: 0rem;
  left: 40%;
  color: var(--white);
  font-size: 1.5rem;
}
.rfm_carousal .react-multi-carousel-track {
  gap: 3rem !important;
}

.RfmAnalysis_div {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
`, "",{"version":3,"sources":["webpack://./src/styles/components/RfmAnalysis.css"],"names":[],"mappings":"AAAA;EACE,UAAU;AACZ;AACA;EACE,sCAAsC;AACxC;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,sCAAsC;EACtC,aAAa;EACb,SAAO;AACT;AACA;EACE,gCAAgC;EAChC,sCAAsC;EACtC,mBAAmB;AACrB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,SAAS;EACT,SAAO;AACT;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,MAAM;EACN,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,SAAS;EACT,uBAAuB;EACvB,UAAU;EACV,cAAc;AAChB;AACA;EACE,wBAAwB;EACxB,oBAAoB;EACpB,uBAAuB;EACvB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,SAAS;EACT,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;EACV,YAAY;EACZ,sCAAsC;EACtC,mBAAmB;AACrB;AACA;EACE,uBAAuB;EACvB,oBAAoB;AACtB;AACA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,UAAU;AACZ;AACA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,aAAa;EACb,sCAAsC;EACtC,mBAAmB;AACrB;AACA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,sCAAsC;AACxC;AACA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,sCAAsC;EACtC,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,2BAA2B;EAC3B,SAAS;EACT,SAAO;AACT;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,cAAc;AAChB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,8BAA8B;EAC9B,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,sCAAsC;AACxC;AACA;EACE,iDAAiD;EACjD,YAAY;EACZ,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,YAAY;AACd;AACA;;;GAGG;AACH;EACE,aAAa;EACb,6BAA6B;EAC7B,SAAS;AACX;AACA;EACE,8BAA8B;AAChC;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sCAAsC;EACtC,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,YAAY;AACd;AACA;EACE,sCAAsC;EACtC,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;AACxB","sourcesContent":[".RfmAnalysis_container {\n  width: 95%;\n}\n.RfmAnalysis_container h1 {\n  color: var(--primary-color) !important;\n}\n.RfmAnalysis_container .heading {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  /* margin-bottom: 6rem; */\n}\n.RfmAnalysis_container .heading h1 {\n  font-size: 2rem;\n  color: var(--primary-color) !important;\n  display: flex;\n  flex: 7;\n}\n.RfmAnalysis_container .heading .ant-select-selector {\n  border-radius: 0.6rem !important;\n  background-color: var(--primary-color);\n  color: var(--white);\n}\n.RfmAnalysis_container .heading .anticon {\n  color: var(--white) !important;\n}\n.RfmAnalysis_container .heading div {\n  display: flex;\n  gap: 2rem;\n  flex: 4;\n}\n.verticalLine {\n  position: absolute;\n  left: 5rem;\n  top: 0;\n  background-color: black;\n  height: 40rem;\n  width: 0.4rem;\n}\n.HorizontalLine {\n  position: absolute;\n  left: 5rem;\n  /* top: 0; */\n  bottom: 0;\n  background-color: black;\n  width: 92%;\n  height: 0.4rem;\n}\n.verticalLine_container h1 {\n  transform: rotate(90deg);\n  margin-bottom: 15rem;\n  /* margin-top: 10rem; */\n  color: black !important;\n}\n.verticalLine_container {\n  display: flex;\n  position: relative;\n  align-items: flex-end;\n  min-height: 40rem;\n  padding-bottom: 2rem;\n}\n.verticalLine_container h2 {\n  position: absolute;\n  bottom: 0;\n  left: 50%;\n  top: 100%;\n  color: black !important;\n  font-size: 25px;\n}\n.RfmAnalysis_container .ReturningCustomer {\n  display: flex;\n  align-items: center;\n  gap: 2rem;\n}\n.RfmAnalysis_container .ReturningCustomer div {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 50%;\n  height: 7rem;\n  background-color: var(--primary-color);\n  border-radius: 1rem;\n}\n.RfmAnalysis_container .ReturningCustomer div h1 {\n  color: white !important;\n  margin: 0 !important;\n}\n.RfmAnalysis_container .ReturningCustomer p {\n  /* font-size: 1.2rem; */\n  font-weight: bold;\n  width: 30%;\n}\n.ReturningCustomer_container {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n.salesAnalysis_container {\n  margin-top: 5rem;\n}\n.salesAnalysis_container h1 {\n  color: black !important;\n  font-size: 2rem;\n}\n.analysisChart_container {\n  padding: 1rem;\n  background-color: var(--primary-color);\n  border-radius: 1rem;\n}\n.analysisChart_container h1 {\n  color: white !important;\n  font-size: 1.5rem;\n  margin-left: 1rem;\n}\n.shopUserRFM_container h1 {\n  color: var(--primary-color) !important;\n}\n.careemBlock_container {\n  display: flex;\n  gap: 2rem;\n  align-items: center;\n}\n.value_container {\n  text-align: center;\n}\n.value_container div {\n  padding: 2rem 5rem;\n  background-color: var(--primary-color);\n  border-radius: 1rem;\n  text-align: center;\n  color: var(--white);\n  font-size: 1.2rem;\n  min-width: 15rem;\n}\n.value_containers_div {\n  display: flex;\n  justify-content: flex-start;\n  gap: 4rem;\n  flex: 8;\n}\n.slider-div {\n  overflow-x: scroll;\n}\n.twelve-month-container {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  margin: 1rem 0;\n}\n.twelve-month-container .twelve-month-card {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin: 0 0.5rem;\n}\n.twelve-month-container .twelve-month-card .title {\n  color: var(--green) !important;\n  font-weight: 600;\n}\n.ScatterChart_header {\n  /* display: flex; */\n  justify-content: space-between;\n  align-items: center;\n}\n.ScatterChart_header h1 {\n  color: var(--primary-color) !important;\n}\n.ScatterChart_header .ant-select:not(.ant-select-customize-input) .ant-select-selector {\n  background-color: var(--primary-color) !important;\n  width: 10rem;\n  color: var(--white);\n  border-radius: 0.5rem;\n}\n.ScatterChart_header .ant-select span {\n  color: white;\n}\n/* .ScatterChart_header div {\n  display: flex;\n  gap: 1rem;\n} */\n.ScatterChart_header_container {\n  display: flex;\n  justify-content: space-evenly;\n  gap: 3rem;\n}\n.ScatterChart_header_container .text_div h1 {\n  color: var(--white) !important;\n}\n.ScatterChart_header_container .text_div li {\n  list-style: none;\n  text-align: left;\n}\n.ScatterChart_header_container .text_div {\n  padding: 2rem;\n  background-color: var(--primary-color);\n  border-radius: 1rem;\n  color: var(--white);\n  height: 20rem;\n  width: 25rem;\n}\n.ScatterChart_header_container .chart_div {\n  background-color: var(--primary-color);\n  padding: 2rem;\n  border-radius: 1rem;\n  width: 100%;\n  position: relative;\n  padding-left: 5rem;\n}\n.ScatterChart_header_container .chart_div .value {\n  position: absolute;\n  bottom: 40%;\n  left: 1%;\n  color: var(--white);\n  font-size: 1.5rem;\n  transform: rotate(-90deg);\n}\n\n.ScatterChart_header_container .chart_div .date {\n  position: absolute;\n  bottom: 0rem;\n  left: 40%;\n  color: var(--white);\n  font-size: 1.5rem;\n}\n.rfm_carousal .react-multi-carousel-track {\n  gap: 3rem !important;\n}\n\n.RfmAnalysis_div {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
